module.exports = __webpack_public_path__ + "img/image5@2x.3167bea1.png";